import api from '../../api/_consultation'

const state = () => ({
    consultation: null,
    consultations: null,
    consultation_id: 0,
    consultationsEnAttente: null,
    todayConsultationsCount: null,
    currentMonthConsultationsCount: null,
    patientConsultations: null,
    etatsPatient: null,
    demandeAnalyses: null,
    prescriptionConsultation: null,
    consultationPatientEnCours: {},

    organe_a_examiner: null,
    list_all_organes: [],

    consultation_ordonnances: [],
    listeDiagnostics: [],

    consultation_diagnostics: [],
    hypothese_diagnostiques: [],

    suitesDeSoins: [],
    protocolesSoins: [],
    facteursPonderations: [],

    //historique de consultation 
    protocolesSoinsHistorique: [],
    demandesAnalysesHistorique: [],
    consultationDiagnosticsHistorique: [],
    consultationHypotheseHistorique: [],

    consultationOrdonnanceHistorique: [],

    formConstantesRempli: [],
    formGrossessesRempli: [],

    recap_historique_consultation: [],

    // Statistiques santé - Diagnostiques
    stats_sante: [],

    liste_all_type_consultations: [],
    soins_h0_constantes: [],
    soins_h0_organes: [],
    soins_hn_organes: [],

    type_appareils: [],
    appareil_examines: [],
    appareil_examines_historique: [],

    protocole_h0_state: 0,

    consultation_commentaires: [],
    consultation_commentaires_historique: [],

    consultation_constantes: [],
    consultation_constante_complementaires: [],

    consultation_examen_cliniques: [],
    list_consultations_with_tarif: [],

    selected_consultation_encours: {},
    can_print_result: false,
    resulat_patient_to_print: {},
    add_result_loader: false
})

// getters
const getters = {
    recap_historique_consultation: (state) => {
        return state.recap_historique_consultation
    },

    consultations: (state) => {
        return state.consultations
    },

    consultation: (state) => {
        return state.consultation
    },

    consultation_id: (state) => {
        return state.consultation_id
    },

    consultationsEnAttente: (state) => {
        return state.consultationsEnAttente
    },
    todayConsultationsCount: (state) => {
        return state.todayConsultationsCount
    },
    currentMonthConsultationsCount: (state) => {
        return state.currentMonthConsultationsCount
    },
    patientConsultations: (state) => {
        return state.patientConsultations
    },
    demandeAnalyses: (state) => {
        return state.demandeAnalyses
    },

    consultationPatientEnCours: (state) => {
        return state.consultationPatientEnCours
    },
    etatsPatient: (state) => {
        return state.etatsPatient
    },

    organe_a_examiner: (state) => {
        return state.organe_a_examiner
    },

    list_all_organes: (state) => {
        return state.list_all_organes
    },

    consultation_ordonnances: (state) => {
        return state.consultation_ordonnances
    },

    listeDiagnostics: (state) => {
        return state.listeDiagnostics
    },

    consultation_diagnostics: (state) => {
        return state.consultation_diagnostics
    },

    hypothese_diagnostiques: (state) => {
        return state.hypothese_diagnostiques
    },

    suitesDeSoins: (state) => {
        return state.suitesDeSoins
    },
    protocolesSoins: (state) => {
        return state.protocolesSoins
    },
    protocolesSoinsHistorique: (state) => {
        return state.protocolesSoinsHistorique
    },
    demandesAnalysesHistorique: (state) => {
        return state.demandesAnalysesHistorique
    },

    consultationDiagnosticsHistorique: (state) => {
        return state.consultationDiagnosticsHistorique
    },

    consultationHypotheseHistorique: (state) => {
        return state.consultationHypotheseHistorique
    },

    consultationOrdonnanceHistorique: (state) => {
        return state.consultationOrdonnanceHistorique
    },
    facteursPonderations: (state) => {
        return state.facteursPonderations
    },
    formConstantesRempli: (state) => {
        return state.formConstantesRempli
    },
    formGrossessesRempli: (state) => {
        return state.formGrossessesRempli
    },

    stats_sante: (state) => {
        return state.stats_sante
    },

    liste_all_type_consultations: (state) => {
        return state.liste_all_type_consultations
    },

    soins_h0_constantes: (state) => {
        return state.soins_h0_constantes
    },

    soins_h0_organes: (state) => {
        return state.soins_h0_organes
    },

    soins_hn_organes: (state) => {
        return state.soins_hn_organes
    },

    type_appareils: (state) => {
        return state.type_appareils
    },

    appareil_examines: (state) => {
        return state.appareil_examines
    },

    appareil_examines_historique: (state) => {
        return state.appareil_examines_historique
    },

    protocole_h0_state: (state) => {
        return state.protocole_h0_state
    },

    consultation_commentaires: (state) => {
        return state.consultation_commentaires
    },

    consultation_commentaires_historique: (state) => {
        return state.consultation_commentaires_historique
    },

    consultation_constantes: (state) => {
        return state.consultation_constantes
    },

    consultation_constante_complementaires: (state) => {
        return state.consultation_constante_complementaires
    },

    consultation_examen_cliniques: (state) => {
        return state.consultation_examen_cliniques
    },

    list_consultations_with_tarif: (state) => {
        return state.list_consultations_with_tarif
    },

    selected_consultation_encours: (state) => {
        return state.selected_consultation_encours
    },

    can_print_result: (state) => {
        return state.can_print_result
    },

    resulat_patient_to_print: (state) => {
        return state.resulat_patient_to_print
    },

    add_result_loader: (state) => {
        return state.add_result_loader
    }
}

// mutations
const mutations = {
    SET_RECAP_HISTORIQUE_CONSULTATION(state, historique) {
        state.recap_historique_consultation = historique
    },

    SET_CONSULTATION(state, consultation) {
        state.consultation = consultation
    },

    SET_CONSULTATION_ID(state, consultation_id) {
        state.consultation_id = consultation_id
    },

    SET_CONSULTATIONS_EN_ATTENTE(state, consultationsEnAttente) {
        state.consultationsEnAttente = consultationsEnAttente
    },
    SET_COUNT_TODAY_CONSULTATIONS(state, todayConsultationsCount) {
        state.todayConsultationsCount = todayConsultationsCount
    },

    SET_COUNT_MONTH_CONSULTATIONS(state, currentMonthConsultationsCount) {
        state.currentMonthConsultationsCount = currentMonthConsultationsCount
    },

    SET_PATIENT_CONSULTATIONS(state, patientConsultations) {
        state.patientConsultations = patientConsultations
    },

    SET_ETATS_PATIENT(state, etatsPatient) {
        state.etatsPatient = etatsPatient
    },

    SET_DEMANDE_ANALYSES(state, demandeAnalyses) {
        state.demandeAnalyses = demandeAnalyses
    },
    SET_PATIENT_LATEST_CONSULTATION(state, consultationPatientEnCours) {
        state.consultationPatientEnCours = consultationPatientEnCours
    },

    SET_ORGANES_A_EXAMINER(state, organe) {
        state.organe_a_examiner = organe
    },

    SET_LIST_ALL_ORGANES(state, organe) {
        state.list_all_organes = organe
    },

    SET_CONSULTATION_ORDONNANCE(state, consultation_ordonnances) {
        state.consultation_ordonnances = consultation_ordonnances
    },

    SET_LISTE_DIAGNOSTICS(state, listeDiagnostics) {
        state.listeDiagnostics = listeDiagnostics
    },

    SET_CONSULTATION_DIAGNOSTICS(state, consultation_diagnostics) {
        state.consultation_diagnostics = consultation_diagnostics
    },

    SET_HYPOTHESE_DIAGNOSTIQUES(state, hypothese_diagnostiques) {
        state.hypothese_diagnostiques = hypothese_diagnostiques
    },

    SET_SUITES_SOINS(state, suitesDeSoins) {
        state.suitesDeSoins = suitesDeSoins
    },

    SET_PROTOCOLES_SOINS(state, protocolesSoins) {
        state.protocolesSoins = protocolesSoins
    },
    SET_PROTOCOLES_SOINS_HISTORIQUE(state, protocolesSoinsHistorique) {
        state.protocolesSoinsHistorique = protocolesSoinsHistorique
    },

    SET_DEMANDE_ANALYSES_HISTORIQUE(state, demandesAnalysesHistorique) {
        state.demandesAnalysesHistorique = demandesAnalysesHistorique
    },

    SET_CONSULTATION_DIAGNOSTICS_HISTORIQUE(state, consultationDiagnosticsHistorique) {
        state.consultationDiagnosticsHistorique = consultationDiagnosticsHistorique
    },

    SET_CONSULTATION_HYPOTHESE_HISTORIQUE(state, consultationHypotheseHistorique) {
        state.consultationHypotheseHistorique = consultationHypotheseHistorique
    },

    SET_CONSULTATION_ORDONNANCE_HISTORIQUE(state, consultationOrdonnanceHistorique) {
        state.consultationOrdonnanceHistorique = consultationOrdonnanceHistorique
    },

    SET_FACTEURS_PONDERATIONS(state, facteursPonderations) {
        state.facteursPonderations = facteursPonderations
    },

    SET_CONSTANTES_REMPLI(state, formConstantesRempli) {
        state.formConstantesRempli = formConstantesRempli
    },
    
    SET_GROSSESSES_REMPLI(state, formGrossessesRempli) {
        state.formGrossessesRempli = formGrossessesRempli
    },

    SET_STATISTIQUE_SANTE(state, stats) {
        state.stats_sante = stats
    },

    SET_LISTE_TYPE_CONSULTATIONS(state, type_consultations) {
        state.liste_all_type_consultations = type_consultations
    },

    SET_SOINS_H0_CONSTANTES(state, constante) {
        state.soins_h0_constantes = constante
    },
    
    SET_SOINS_H0_ORGANES(state, organes) {
        state.soins_h0_organes = organes
    },

    SET_SOINS_HN_ORGANES(state, organes) {
        state.soins_hn_organes = organes
    },

    SET_TYPE_APPAREILS(state, historique) {
        state.type_appareils = historique
    },

    SET_APPAREIL_EXAMINES(state, historique) {
        state.appareil_examines = historique
    },

    SET_APPAREIL_EXAMINES_HISTORIQUE(state, historique) {
        state.appareil_examines_historique = historique
    },

    SET_PROTOCOLE_H0_STATE(state, etat) {
        state.protocole_h0_state = etat
    },

    SET_CONSULTATION_COMMENTAIRES(state, historique) {
        state.consultation_commentaires = historique
    },

    SET_CONSULTATION_COMMENTAIRES_HISTORIQUE(state, historique) {
        state.consultation_commentaires_historique = historique
    },

    SET_CONSULTATION_CONSTANTES(state, cste) {
        state.consultation_constantes = cste
    },

    SET_CONSULTATION_CONSTANTE_COMPLEMENTAIRES(state, cste) {
        state.consultation_constante_complementaires = cste
    },

    SET_CONSULTATION_EXAMEN_CLINIQUES(state, examens) {
        state.consultation_examen_cliniques = examens
    },

    SET_LIST_CONSULTATIONS_WITH_TARIF(state, list) {
        state.list_consultations_with_tarif = list
    },

    SET_SELECTED_CONSULTATION_ENCOURS(state, historique) {
        state.selected_consultation_encours = historique
    },

    SET_CAN_PRINT_RESULT(state, can_print_result) {
        state.can_print_result = can_print_result
    },

    SET_RESULAT_PATIENT_TO_PRINT(state, resultat) {
        state.resulat_patient_to_print = resultat
    },

    SET_ADD_RESULT_LOADER(state, loader) {
        state.add_result_loader = loader
    },
}


const actions = {
    putConstante({ commit, dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.putConstante(id, data).then(
                response => {
                    commit('SET_CONSULTATION')
                    dispatch('getConsultationsEnAttente')
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationsEnAttente({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationAttente(data).then(response => {
                resolve(response)
                commit('SET_CONSULTATIONS_EN_ATTENTE', response)
            }, error => {
                reject(error)
            })
        })
    },

    getCountTodayConsultations({ commit }, type_cons) {
        return new Promise((resolve, reject) => {
            api.getCountTodayConsultations(type_cons).then(response => {
                resolve(response)
                commit('SET_COUNT_TODAY_CONSULTATIONS', response)
            }, error => {
                reject(error)
            })
        })

    },

    getCountMonthConsultations({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getCountMonthConsultations(data.month, data.type_cons).then(response => {
                resolve(response)
                commit('SET_COUNT_MONTH_CONSULTATIONS', response)
            }, error => {
                reject(error)
            })
        })

    },

    getPatientConsultationId({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getPatientConsultationId(patient_id).then(
                response => {
                    resolve(response)
                    commit('SET_CONSULTATION_ID', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPatientConsultations({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getPatientConsultations(id).then(
                response => {
                    resolve(response)
                    commit('SET_PATIENT_CONSULTATIONS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getHistoriqueCpn({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPatientConsultations(data.id, data.cpn).then(
                response => {
                    resolve(response)
                    commit('SET_PATIENT_CONSULTATIONS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getDemandeAnalyses({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getDemandeAnalyses(data.id).then(
                response => {
                    resolve(response)

                    if (data.enCours === true) {
                        commit('SET_DEMANDE_ANALYSES', response)
                    } else {
                        commit('SET_DEMANDE_ANALYSES_HISTORIQUE', response)
                    }

                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteDemandeAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDemandeAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    selectAnalyse({ commit, dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.selectAnalyse(id, data).then(
                response => {
                    commit('SET_CONSULTATION')
                    dispatch('getConsultationsEnAttente')
                    dispatch('getDemandeAnalyses', { id: id, enCours: true })
                    resolve(response);

                }, error => {
                    reject(error)
                }
            )
        })
    },


    getConsultationPatientEnCours({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPatientLatestConsultation(data).then(
                response => {
                    resolve(response)
                    commit('SET_PATIENT_LATEST_CONSULTATION', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getEtatsPatient({ commit }) {
        return new Promise((resolve, reject) => {
            api.getEtatsPatient().then(
                response => {
                    resolve(response)
                    commit('SET_ETATS_PATIENT', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getOrganesAExaminer({ commit }) {
        return new Promise((resolve, reject) => {
            api.getOrganesAExaminer().then(
                response => {
                    resolve(response)
                    commit('SET_LIST_ALL_ORGANES', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    attachOrganesAExaminer({ dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.attachOrganesAExaminer(id, data).then(
                response => {
                    resolve(response),
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveOrgane({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveOrgane(data).then(
                response => {
                    resolve(response),
                        dispatch('getOrganesAExaminer')
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getOrganesAExaminerNotSelected({ commit }, consultationId) {
        return new Promise((resolve, reject) => {
            api.getOrganesAExaminerNotSelected(consultationId).then(
                response => {
                    resolve(response),
                        commit('SET_ORGANES_A_EXAMINER', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveConsultationOrdonnance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationOrdonnance(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveExamenClinique({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.saveExamenClinique(data).then(
                response => {
                    resolve(response)
                    commit('SET_PATIENT_LATEST_CONSULTATION', data)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveMotifHistoire({ commit }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.saveMotifHistoire(id, data).then(
                response => {
                    resolve(response)
                    commit('SET_PATIENT_LATEST_CONSULTATION', data)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveHypothesesDiagnostiques({ dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.saveHypothesesDiagnostiques(id, data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationOrdonnance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationOrdonnance(data).then(
                response => {
                    if (data.enCours === true) {
                        commit('SET_CONSULTATION_ORDONNANCE', response)
                    } else {
                        commit('SET_CONSULTATION_ORDONNANCE_HISTORIQUE', response)
                    }
                    resolve(response);

                }, error => {
                    reject(error)
                }
            )
        })
    },

    removePrescription({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removePrescription(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteOrdonnance({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteOrdonnance(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updatePrescription({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.updatePrescription(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeDiagnostics({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeDiagnostics().then(
                response => {
                    resolve(response)
                    commit('SET_LISTE_DIAGNOSTICS', response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getConsultationDiagnostics({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationDiagnostics(data).then(
                response => {
                    if (data.enCours === true) {
                        if (data.is_diagnostic == 0) { // Hypothèse diagnostique
                            commit('SET_HYPOTHESE_DIAGNOSTIQUES', response)
                        } else if (data.is_diagnostic == 1) {                        // Diagnostic
                            commit('SET_CONSULTATION_DIAGNOSTICS', response)
                        }
                    } else {
                        if (data.is_diagnostic == 0) { // Hypothèse diagnostique
                            commit('SET_CONSULTATION_HYPOTHESE_HISTORIQUE', response)
                        } else if (data.is_diagnostic == 1) {                        // Diagnostic
                            commit('SET_CONSULTATION_DIAGNOSTICS_HISTORIQUE', response)
                        }

                        // commit('SET_CONSULTATION_DIAGNOSTICS_HISTORIQUE', response)
                    }
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    saveConsultationDiagnostic({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationDiagnostic(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    removeDignostic({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removeDignostic(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteDiagnosisGroup({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDiagnosisGroup(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    endConsultation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.endConsultation(data).then(
                response => {
                    resolve(response)
                    dispatch('getConsultationDiagnostics', data.consultation_id)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getSuitesSoins({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSuitesSoins(data).then(
                response => {
                    resolve(response)
                    commit('SET_SUITES_SOINS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    
    getSuitesSoinsCpn({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSuitesSoins(data).then(
                response => {
                    resolve(response)
                    commit('SET_SUITES_SOINS', response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    saveProtocolesSoins({ dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.saveProtocoleSoins(id, data).then(
                response => {
                    resolve(response)
                    dispatch('getProtocolesSoins', { id: id, enCours: true })

                }, error => {
                    reject(error)
                }

            )
        })
    },

    getProtocolesSoins({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getProtocolesSoins(data.id).then(
                response => {
                    resolve(response)
                    if (data.enCours === true) {
                        commit('SET_PROTOCOLES_SOINS', response)
                    } else {
                        commit('SET_PROTOCOLES_SOINS_HISTORIQUE', response)
                    }

                }, error => {
                    reject(error)
                }

            )
        })
    },

    getFacteursPonderations({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getCpnFacteursPonderations(data.id).then(
                response => {
                    resolve(response)
                    if (data.enCours === true) {
                        commit('SET_FACTEURS_PONDERATIONS', response)
                    }
                }, error => {
                    reject(error)
                }

            )
        })
    },

    updateFacteursPonderations({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.updateFacteursPonderations(data.id, data.facteurs).then(
                response => {
                    resolve(response)
                    commit
                }, error => {
                    reject(error)
                }
            )
        })
    },

    savePlaintes({commit},{id,data}){
        return new Promise((resolve,reject) =>{
            api.savePlaintes(id,data).then(
                response =>{
                    resolve(response)
                    commit
                }, error =>{
                    reject(error)
                } 
            )
        })
    },

    /**
     * Supprimer une Conduite à tenir
     * @param {*} param0 
     * @param {*} data   // Contains data sent via CAT form
     * @returns 
     */
    deleteCat({ dispatch }, { consultation_id, protocole_id }) {
        return new Promise((resolve, reject) => {
            api.deleteCAT(protocole_id).then(
                response => {
                    resolve(response)
                    dispatch('getProtocolesSoins', { id: consultation_id, enCours: true })
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getStatistiqueSante({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getStatistiqueSante(data).then(
                response => {
                    resolve(response)
                    commit('SET_STATISTIQUE_SANTE', response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getListeTypeConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeTypeConsultations().then(response => {
                resolve(response)
                commit('SET_LISTE_TYPE_CONSULTATIONS', response)
            }, error => {
                reject(error)
            })
        })
    },

    saveTypeConsultation({dispatch}, data){
        return new Promise((resolve,reject) => {
            api.saveTypeConsultation(data).then(
                response => {
                    dispatch('getListeTypeConsultations')
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    deleteTypeConsultation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteTypeConsultation(data).then(
                response => {
                    dispatch('getListeTypeConsultations')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConstanteSoinsH0({ commit }, consultation_id) {
        return new Promise((resolve, reject) => {
            api.getConstanteSoinsH0(consultation_id).then(response => {
                resolve(response)
                commit('SET_SOINS_H0_CONSTANTES', response)
            }, error => {
                reject(error)
            })
        })
    },

    getOrganeSoinsH0({ commit }, consultation_id) {
        return new Promise((resolve, reject) => {
            api.getOrganeSoinsH0(consultation_id).then(response => {
                resolve(response)
                commit('SET_SOINS_H0_ORGANES', response)
            }, error => {
                reject(error)
            })
        })
    },

    getTypeAppareils({ commit }) {
        return new Promise((resolve, reject) => {
            api.getTypeAppareils().then(response => {
                resolve(response)
                commit('SET_TYPE_APPAREILS', response)
            }, error => {
                reject(error)
            })
        })
    },

    /**
     * 
     * @param {*} param0 
     * @param {*} data 
     * @deprecated
     * @returns 
     */
    getTypeAppareilExamines({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTypeAppareilExamines(data).then(response => {
                resolve(response)
                if (data.est_encours == true) {
                    commit('SET_APPAREIL_EXAMINES', response)
                } else {
                    commit('SET_APPAREIL_EXAMINES_HISTORIQUE', response)
                }
                
            }, error => {
                reject(error)
            })
        })
    },

    getListeConsultationExamenClinique({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeConsultationExamenClinique(data).then(response => {
                resolve(response)
                if (data.est_encours == true) {
                    commit('SET_CONSULTATION_EXAMEN_CLINIQUES', response)
                } else {
                    commit('SET_APPAREIL_EXAMINES_HISTORIQUE', response)
                }
                
            }, error => {
                reject(error)
            })
        })
    },

    storeAppareil({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.storeAppareil(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    storeAppareilAExaminer({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.storeAppareilAExaminer(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    deleteAppareilFromExamenClinique({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteAppareilFromExamenClinique(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    deleteGroupAppareilFromExamenClinique({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteGroupAppareilFromExamenClinique(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    saveObservationAppareil({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveObservationAppareil(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    deleteAppareilObservation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteAppareilObservation(data).then(response => {
                resolve(response)
                dispatch
            }, error => {
                reject(error)
            })
        })
    },

    getEtatProtocoleEnH0({ commit }, consultation_id) {
        return new Promise((resolve, reject) => {
            api.getEtatProtocoleEnH0(consultation_id).then(response => {
                resolve(response)
                commit('SET_PROTOCOLE_H0_STATE', response)
            }, error => {
                reject(error)
            })
        })
    },

    getConsultationInfoComplementaire({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationInfoComplementaire(data).then(response => {
                if (data.est_encours) {
                    commit('SET_CONSULTATION_COMMENTAIRES', response)
                } else {
                    commit('SET_CONSULTATION_COMMENTAIRES_HISTORIQUE', response)
                }
                
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    saveConsultationInfoComplementaire({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationInfoComplementaire(data).then(response => {
                dispatch("getConsultationInfoComplementaire", data)
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    deleteConsultationInfoComplementaire({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteConsultationInfoComplementaire(data).then(response => {
                dispatch("getConsultationInfoComplementaire", data)
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    getConsultationConstante({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationConstante(data).then(response => {
                resolve(response)
                commit('SET_CONSULTATION_CONSTANTES', response)
            }, error => {
                reject(error)
            })
        })
    },

    getConsultationConstanteComplementaire({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationConstanteComplementaire(data).then(response => {
                resolve(response)
                commit('SET_CONSULTATION_CONSTANTE_COMPLEMENTAIRES', response)
            }, error => {
                reject(error)
            })
        })
    },

    saveConsultationConstante({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationConstante(data).then(response => {
                dispatch
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    deleteConsultationConstante({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteConsultationConstante(data).then(response => {
                dispatch
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    getTarifsConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getTarifsConsultations().then(response => {
                resolve(response)
                commit('SET_LIST_CONSULTATIONS_WITH_TARIF', response)
            }, error => {
                reject(error)
            })
        })
    },

    saveDureeBonConsultations({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDureeBonConsultations(data).then(response => {
                dispatch
                resolve(response)
            }, error => {
                reject(error)
            })
        })
    },

    saveNextRDV({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveNextRDV(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}